import { allAnswer } from "../../../normalMode/prefab/forecast/allAnswerConfig";
import getOneSpendEventById from "../../config/SpendEventConfig";
import { DialogInfo, NpcEventRel, SpendModeDataI, SpendModeEventI } from "../../config/SpendInterface";
import spendMode from "../../spendMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SpendHousePrefab extends cc.Component {

    eventRel:NpcEventRel = null;

    gameLayer:spendMode = null;

    @property({type:cc.Node,displayName:"对话节点"})
    chatNode:cc.Node = null;

    bindData(npcItem:NpcEventRel,gameLayer:spendMode){
        this.gameLayer = gameLayer;
        this.eventRel = npcItem;
        this.updateDialog();
    }

    async updateDialog(){
        let id = this.eventRel.eventId;
        let info : DialogInfo = getOneSpendEventById(id).dialogInfo;
        let texts = []
        if(this.eventRel.remainCoins>0){
            // 已投资
            texts = info.agreeTxt;
        }else{
            texts = info.refuseTxt;
        }
        if(info){
            for(let i = 0;i<texts.length;i++){
                this.chatNode.scale = 0;
                let chatLb:cc.Label = this.chatNode.getComponent("chat").getComponent(cc.Label);
                chatLb.string = info.agreeTxt[i];
                await new Promise<void>(resolve=>{
                    if(this.chatNode.scale < 1){
                        cc.tween(this.chatNode).to(0.5,{scale:1},{easing:cc.easing.backOut}).start();
                        this.scheduleOnce(resolve,.5);
                    }else{
                        resolve();
                    }
                });
                await new Promise<void>(resolve=>{
                    this.scheduleOnce(resolve,2);
                });
            }
        }
    }
    // 
    onBtnClick(){
        this.gameLayer.openOneEvent(this.eventRel.eventId);
    }

}
